import {createApp} from 'vue'
import App from './Index'
import router from './router'
import vant from 'vant';
import 'vant/lib/index.css'
import '@vant/touch-emulator';
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

// 定义特性标志
window.__VUE_PROD_DEVTOOLS__ = false;
window.__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false;

const app = createApp(App);
router.beforeEach((to, from, next) => {
    if (from.name === 'HomePage' && to.name === 'UserList') {
        to.meta['keepAlive'] = true;
    }
    if (from.name === 'UserList' && to.name === 'HomePage') {
        from.meta['keepAlive'] = false;
    }
    if (from.name === 'UserList' && to.name === 'ResumeInfo') {
        from.meta['keepAlive'] = true;
    }
    if (from.name === 'ResumeInfo' && to.name === 'UserList') {
        to.meta['keepAlive'] = true;
    }

    if (from.name === 'HomePage' && to.name === 'UserAcceptList') {
        to.meta['keepAlive'] = true;
    }
    if (from.name === 'UserAcceptList' && to.name === 'HomePage') {
        from.meta['keepAlive'] = false;
    }
    if (from.name === 'UserAcceptList' && to.name === 'ResumeAcceptInfo') {
        from.meta['keepAlive'] = true;
    }
    if (from.name === 'ResumeAcceptInfo' && to.name === 'UserAcceptList') {
        to.meta['keepAlive'] = true;
    }

    next();
});
app.use(router);
app.use(vant);
app.use(ElementPlus);
app.mount('#app');